<template>
  <PageLayout>
    <!-- <Header /> -->
    <!-- <GlobalNavigationBar /> -->
    <slot name="gnb">

    </slot>  
    <!---------- 시작 : OuterWrap ---------->
    <div id="outer-wrap">
      <slot></slot>
    </div>
    <!---------- 끝 : wrapper ---------->
  </PageLayout>
</template>

<script>
import { PageLayout } from '@appbase/templates'
export default {
  components: { PageLayout },
  props: { useLeft: { type: Boolean, default: true } },
}
</script>

<style></style>
